module.exports = __webpack_public_path__ + "static/team-img2-93654c43154823dafed2994846d83e1d.jpg";